var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15C6.4625 15 5.4875 14.803 4.575 14.409C3.6625 14.015 2.86875 13.4808 2.19375 12.8063C1.51875 12.1313 0.9845 11.3375 0.591 10.425C0.1975 9.5125 0.0005 8.5375 0 7.5C0 6.4625 0.197 5.4875 0.591 4.575C0.985 3.6625 1.51925 2.86875 2.19375 2.19375C2.86875 1.51875 3.6625 0.9845 4.575 0.591C5.4875 0.1975 6.4625 0.0005 7.5 0C8.5375 0 9.5125 0.197 10.425 0.591C11.3375 0.985 12.1313 1.51925 12.8063 2.19375C13.4813 2.86875 14.0157 3.6625 14.4097 4.575C14.8037 5.4875 15.0005 6.4625 15 7.5C15 8.5375 14.803 9.5125 14.409 10.425C14.015 11.3375 13.4808 12.1313 12.8063 12.8063C12.1313 13.4813 11.3375 14.0157 10.425 14.4097C9.5125 14.8037 8.5375 15.0005 7.5 15ZM7.5 13.5C9.175 13.5 10.5937 12.9187 11.7562 11.7562C12.9187 10.5937 13.5 9.175 13.5 7.5C13.5 6.825 13.3905 6.175 13.1715 5.55C12.9525 4.925 12.637 4.35 12.225 3.825L3.825 12.225C4.35 12.6375 4.925 12.9532 5.55 13.1722C6.175 13.3912 6.825 13.5005 7.5 13.5ZM2.775 11.175L11.175 2.775C10.65 2.3625 10.075 2.047 9.45 1.8285C8.825 1.61 8.175 1.5005 7.5 1.5C5.825 1.5 4.40625 2.08125 3.24375 3.24375C2.08125 4.40625 1.5 5.825 1.5 7.5C1.5 8.175 1.60925 8.825 1.82775 9.45C2.04625 10.075 2.362 10.65 2.775 11.175Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.bd9bedc45adfab1daeeeb867eaa81234.svg";
export { ForwardRef as ReactComponent };